var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	1493: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_common_mjs-_ec490").then(() => (() => (__webpack_require__(/*! @angular/common */ 4666))))))),
	2348: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_observers_mjs-_9dd21").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 3773))))))),
	2597: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/platform", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_platform_mjs-_eeec1").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 9107))))))),
	5210: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_coercion_mjs-_e7881").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 8971))))))),
	6269: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 2560))))))),
	7308: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 8456))))))),
	8829: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/layout", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_layout_mjs-_516e1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 3278))))))),
	4414: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/collections", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_collections_mjs-_15111").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 1755))))))),
	3916: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c1").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 4218))))))),
	851: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_overlay_mjs-_4b201").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 5895))))))),
	565: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/portal", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_portal_mjs-_32ad1").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 7520))))))),
	4968: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb1").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 2867))))))),
	4051: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_scrolling_mjs-_93761").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 6328))))))),
	3201: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/router", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_router_fesm2020_router_mjs-_6f000").then(() => (() => (__webpack_require__(/*! @angular/router */ 124))))))),
	2023: () => (loadStrictSingletonVersionCheckFallback("default", "@xpo-ltl/config-manager", [2,15,1,1], () => (__webpack_require__.e("node_modules_xpo-ltl_config-manager_fesm2020_xpo-ltl-config-manager_mjs-_2a0e0").then(() => (() => (__webpack_require__(/*! @xpo-ltl/config-manager */ 9162))))))),
	2497: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_http_mjs-_68760").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 8987))))))),
	2129: () => (loadStrictSingletonVersionCheckFallback("default", "@xpo-ltl/ngx-ops-state", [2,15,0,5], () => (__webpack_require__.e("node_modules_xpo-ltl_ngx-ops-state_fesm2020_xpo-ltl-ngx-ops-state_mjs-_166b0").then(() => (() => (__webpack_require__(/*! @xpo-ltl/ngx-ops-state */ 6746))))))),
	8011: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/dialog", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_dialog_mjs-_b1e00").then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 2529))))))),
	8859: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_cdk_mjs-_1e770").then(() => (() => (__webpack_require__(/*! @angular/cdk */ 6507))))))),
	8947: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/clipboard", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_clipboard_mjs-_3a890").then(() => (() => (__webpack_require__(/*! @angular/cdk/clipboard */ 6079))))))),
	5620: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/text-field", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_text-field_mjs-_d10b0").then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 5804))))))),
	8214: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/accordion", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_accordion_mjs-_cc710").then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 2088))))))),
	615: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/drag-drop", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_drag-drop_mjs-_11e30").then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 7727))))))),
	4270: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/table", [1,15,0,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_table_mjs-_f6c20").then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 9673)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c0": [
		1493,
		2348,
		2597,
		5210,
		6269,
		7308,
		8829
	],
	"node_modules_angular_cdk_fesm2020_accordion_mjs-_cc711": [
		6269,
		4414,
		5210
	],
	"node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb0": [
		1493,
		6269
	],
	"node_modules_angular_cdk_fesm2020_clipboard_mjs-_3a891": [
		1493,
		6269
	],
	"node_modules_angular_cdk_fesm2020_coercion_mjs-_e7880": [
		6269
	],
	"node_modules_angular_cdk_fesm2020_collections_mjs-_15110": [
		6269
	],
	"node_modules_angular_cdk_fesm2020_dialog_mjs-_b1e01": [
		3916,
		851,
		2597,
		565,
		1493,
		6269,
		7308,
		4968
	],
	"node_modules_angular_cdk_fesm2020_drag-drop_mjs-_11e31": [
		6269,
		1493,
		4051,
		2597,
		5210,
		3916,
		4968
	],
	"node_modules_angular_cdk_fesm2020_layout_mjs-_516e0": [
		2597,
		5210,
		6269
	],
	"node_modules_angular_cdk_fesm2020_observers_mjs-_9dd20": [
		5210,
		6269
	],
	"node_modules_angular_cdk_fesm2020_overlay_mjs-_4b200": [
		565,
		1493,
		2597,
		4051,
		4968,
		5210,
		6269,
		7308
	],
	"node_modules_angular_cdk_fesm2020_platform_mjs-_eeec0": [
		1493,
		6269
	],
	"node_modules_angular_cdk_fesm2020_portal_mjs-_32ad0": [
		1493,
		6269
	],
	"node_modules_angular_cdk_fesm2020_scrolling_mjs-_93760": [
		1493,
		2597,
		4414,
		4968,
		5210,
		6269
	],
	"node_modules_angular_cdk_fesm2020_table_mjs-_f6c21": [
		4968,
		5210,
		4414,
		2597,
		4051,
		1493,
		6269
	],
	"node_modules_angular_cdk_fesm2020_text-field_mjs-_d10b1": [
		2597,
		6269,
		5210,
		1493
	],
	"node_modules_angular_cdk_fesm2020_cdk_mjs-_1e771": [
		6269
	],
	"node_modules_angular_common_fesm2020_http_mjs-_68761": [
		1493,
		6269
	],
	"node_modules_angular_common_fesm2020_common_mjs-_ec491": [
		6269
	],
	"node_modules_angular_router_fesm2020_router_mjs-_6f001": [
		6269,
		1493
	],
	"node_modules_xpo-ltl_config-manager_fesm2020_xpo-ltl-config-manager_mjs-_2a0e1": [
		6269
	],
	"node_modules_xpo-ltl_ngx-ops-state_fesm2020_xpo-ltl-ngx-ops-state_mjs-_166b1": [
		6269
	],
	"src_bootstrap_ts": [
		6269,
		3201,
		2023,
		2497,
		1493,
		5210,
		8829,
		2129,
		851,
		3916,
		8011,
		565,
		7308,
		4968,
		8859,
		2597,
		4051,
		4414,
		8947,
		5620,
		2348,
		8214
	],
	"node_modules_angular_cdk_fesm2020_platform_mjs-_eeec1": [
		1493
	],
	"node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c1": [
		2348,
		5210,
		7308,
		8829
	],
	"node_modules_angular_cdk_fesm2020_overlay_mjs-_4b201": [
		4051,
		5210
	],
	"node_modules_angular_cdk_fesm2020_scrolling_mjs-_93761": [
		4414
	],
	"src_app_ops-dimensioner_ops-dimensioner_module_ts-_7a2c0": [
		615,
		4270
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}